var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"aria-label":_vm.caption,"to":_vm.link}},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"sidebar-hidden-closed"},[_vm._v(_vm._s(_vm.caption))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }